import { FC, ReactNode } from "react";

import { sendAIChatQuery } from "components/ai/queries/chat-query";
import { SECONDARY_OVERLAY_QUERY_PARAM, SecondaryOverlay } from "components/constants";
import { IconText } from "mds/components/IconText";
import { TrackedDiv } from "mds/components/TrackedDiv";
import { DoubleSparkleIcon } from "mds/icons";
import { useAppDispatch } from "store/index";
import { aiStateActions } from "store/slices/ai";
import { ComponentEventProperties } from "utils/amplitude";
import { useQueryParamsActions } from "utils/routing";

export type AIActionSuggestionProps = ComponentEventProperties & {
  fragment: string;
  fullText: string;
};

export const AIActionSuggestion: FC<AIActionSuggestionProps> = ({ fragment, fullText }) => {
  const { setQueryParams } = useQueryParamsActions();
  const dispatch = useAppDispatch();

  const onClick = () => {
    // Ensure AI tab is open
    setQueryParams({ [SECONDARY_OVERLAY_QUERY_PARAM]: SecondaryOverlay.AIAssistant });
    dispatch(aiStateActions.clearAiChatMessages());
    sendAIChatQuery(dispatch, fullText);
  };

  return (
    <TrackedDiv
      className="w-fit shrink-0 cursor-pointer whitespace-nowrap rounded-lg border border-black-tint-90 bg-white py-1.5 pl-3 pr-2 text-sm text-black-tint-40"
      eventName="AI Action Suggestion"
      eventProps={{ message: fragment }}
      onClick={onClick}
    >
      <IconText iconEnd={<DoubleSparkleIcon />} text={fragment} />
    </TrackedDiv>
  );
};

export const AIActionSuggestionRow: FC<{ children: ReactNode }> = ({ children }) => (
  <div className="mt-2 flex w-full min-w-0 flex-wrap gap-2">{children}</div>
);
